import { jsx as _jsx } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Chip, darken } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
export const LoadedFileChip = ({ fileName, handleDelete, buttonColor, }) => {
    return (_jsx(Chip, { sx: {
            height: "27px",
            color: buttonColor,
            "& .MuiChip-deleteIcon": {
                color: buttonColor,
                "&:hover": { color: "#b7b7b7" },
            },
            backgroundColor: buttonColor && darken(buttonColor, 0.73),
        }, label: fileName.length > 20 ? `${fileName.slice(0, 20)}...` : fileName, onDelete: handleDelete, deleteIcon: _jsx(CancelIcon, {}) }));
};
